export const PHYSICAL_API = {
  senders: '/physical/sender',
  receivers: '/physical/receiver',
  addresses: '/physical/address',
  terms: '/physical/terms',
  groups: '/physical/groups',
  orders: '/physical/orders',
  ordersLimitCheck: '/physical/orders/limit-check',
  pallets: '/physical/pallets',
  airwayBills: '/physical/airway-bills',
  ordersDeliverySlots: '/physical/orders/delivery-slots',
  ordersCheckedByMe: '/physical/orders/checked-by-me',
  ordersPickupByTracking: '/physical/orders/pickup/by-tracking',
  ordersPickupByPhone: '/physical/orders/pickup/by-phone',
  ordersTbilisiWarehouseCsv: '/physical/orders/export/tbilisi-warehouse',
  rsExport: '/physical/customs/rs/export',
  rsUpload: '/physical/customs/rs/upload',
  payments: '/physical/payments',
  statuses: '/physical/statuses',
  deliveryAreas: '/physical/delivery-areas',
  statusesBulk: '/physical/statuses/bulk',
  statusesDispatch: '/physical/statuses/dispatch',
  shelves: '/physical/shelves',
};

export const PHYSICAL_DIRECTIONS = {
  USA_GE: 'USA_GE',
  GE_USA: 'GE_USA',
};

export const PHYSICAL_DIRECTION_LABELS = {
  [PHYSICAL_DIRECTIONS.USA_GE]: 'USA → Georgia',
  [PHYSICAL_DIRECTIONS.GE_USA]: 'Georgia → USA',
};

export const withoutEmptyValues = (values = {}) =>
  Object.fromEntries(
    Object.entries(values).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== '' &&
        !(Array.isArray(value) && value.length === 0)
    )
  );

export const emptyToNull = (values = {}) =>
  Object.fromEntries(
    Object.entries(values).map(([key, value]) => [key, value === '' ? null : value])
  );

export const destinationDeliveryOf = (order) =>
  order?.physicalDetails?.destination_delivery ?? order?.delivery ?? null;

export const physicalErrorMessage = (error, fallback = 'Request failed') => {
  const data = error?.response?.data;
  return [].concat(data?.message ?? data?.error ?? fallback).join(', ');
};

export const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});
